<template>
  <section class="backstage">
    <h3 class="backstage-title">
      <span class="line"></span>
      <span class="text">后台FAQ</span>
      <span class="line"></span>
    </h3>

    <dl class="qa">
      <dt class="ask">问：测试区可以收费么？</dt>
      <dd class="answer">答：开发者开发的内容在测试区开放是为开发者收集bug的，正式区会开放给开发者收费的选项和接口，测试区属于免费区，开发者可以在测试区验证付费的内容，但是无法收费。</dd>
    </dl>

    <dl class="qa">
      <dt class="ask">问：地图mod和私服mod有什么区别？</dt>
      <dd class="answer">答：地图mod是单局玩法，不需要拥有服务器，私服mod是需要购买服务器，向其他玩家提供私服内容。</dd>
    </dl>
  </section>
</template>

<script type="text/ecmascript-6">
  export default {
    // 后台faq
    name: 'backstage'
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "backstage.styl";
</style>



// WEBPACK FOOTER //
// src/views/backstage/backstage.vue